import React from 'react'
import noImage from 'images/no-image.png'

const ImageCard = (props) => {
  const { media, status = 'missing', index, isSelected = false, handleSelect, handleDoubleClick } = props
  const isVideo = media?.type?.startsWith?.('video/')

  // return
  return (
    <div
      className={`image-card ${isSelected ? 'image-card__selected' : ''}`}
      onClick={handleSelect}
      onDoubleClick={handleDoubleClick}
    >
      {media !== null ? (
        isVideo ? (
          <video className='image-card-image' src={media?.url} muted playsInline preload="metadata" />
        ) : (
          <img className='image-card-image' src={media?.url} alt={media?.name} />
        )
      ) : (
        <img className='image-card-image' src={noImage} alt="No image" />
      )}

      <div className={`image-card-status image-card-status__${status}`}/>

      <div className='image-card-number'>{index + 1}</div>
    </div>
  )
}

export default ImageCard